//个人中心
export default [{
	//首页
	path: '/personal',
	name: 'personal',
	component: () => import('@/views/personal/personal.vue')
},{
	//课程列表
	path: '/curriculum',
	name: 'curriculum',
	component: () => import('@/views/personal/curriculum.vue')
},{
	//基本资料
	path: '/information',
	name: 'information',
	component: () => import('@/views/personal/information.vue')
},{
	//我的订单
	path: '/order',
	name: 'order',
	component: () => import('@/views/personal/order.vue')
},{
	//查看发票
	path: '/lookReceipt',
	name: 'lookReceipt',
	component: () => import('@/views/personal/lookReceipt.vue')
},{
	//开具发票
	path: '/writeReceipt',
	name: 'writeReceipt',
	component: () => import('@/views/personal/writeReceipt.vue')
},{
	//我的考试
	path: '/myExamination',
	name: 'myExamination',
	component: () => import('@/views/personal/myExamination.vue')
},{
	//错题记录
	path: '/wrong',
	name: 'wrong',
	component: () => import('@/views/personal/wrong.vue')
},{
	//园区资料
	path: '/gardenInfo',
	name: 'gardenInfo',
	component: () => import('@/views/personal/gardenInfo.vue')
},{
	//课程详情
	path: '/curriculumDetails',
	name: 'curriculumDetails',
	component: () => import('@/views/personal/curriculumDetails.vue')
}]


// WEBPACK FOOTER //
// ./src/router/modules/personal.js